<template>
  <div class="fullHeight">
    <div class="logo">
      <img src="../../../static/logos/lcp-logo.svg" width="312" alt="">
    </div>
    <mu-flexbox align="center" justify="center" v-if="showFlashMessage">
      <mu-flexbox-item>
        <mu-row>
          <mu-col desktop="25" tablet="25"></mu-col>
          <mu-col desktop="50" tablet="50" class="animated fadeInDown">
            <MessageBox :message-type="flashMessageType" :message="flashMessageBody" :title="flashMessageTitle"></MessageBox>
          </mu-col>
          <mu-col desktop="25" tablet="25"></mu-col>
        </mu-row>
      </mu-flexbox-item>
    </mu-flexbox>
    <mu-flexbox align="center" justify="center" v-bind:class="{'fullHeight' : !showFlashMessage}" >
      <mu-flexbox-item>
        <mu-row>
          <mu-col desktop="25" tablet="25"></mu-col>
          <mu-col desktop="50" tablet="50" class="animated fadeInDown">
            <mu-card class="reset-block">
              <mu-card-header
                title="Reset your password"
                subTitle="Use the form below to reset your password"
                titleClass="blueTitle largeTitle regTitle resetTitle"
              ></mu-card-header>
              <mu-card-text>
                <form @submit.prevent="submitForm">
                  <mu-row gutter>
                    <mu-col width="100" desktop="50" tablet="50">
                      <mu-text-field
                        name="password"
                        v-validate="'required'"
                        ref="password"
                        data-vv-name="password"
                        data-vv-value-path="inputValue"
                        data-vv-as="Password"
                        :errorText="errors.first('password')"
                        label="New password"
                        type="password"
                        v-model="model.password"
                        hintText="Enter desired password"
                        @change="triggerValidate"
                        fullWidth
                      ></mu-text-field>
                    </mu-col>
                  </mu-row>
                  <mu-row gutter>
                    <mu-col width="100" desktop="100" tablet="100">
                      <password-strength-validation :password="model.password"></password-strength-validation>
                    </mu-col>
                  </mu-row>
                  <mu-row>
                    <mu-col width="100" desktop="50" tablet="50">
                      <mu-text-field
                        name="password_confirmation"
                        v-validate="'required|confirmed:password'"
                        data-vv-name="password_confirmation"
                        data-vv-value-path="inputValue"
                        data-vv-as=" "
                        :errorText="confirmPassErr"
                        label="Confirm password"
                        type="password"
                        v-model="model.password_confirm"
                        hintText="Confirm password"
                        @change="triggerValidate"
                        fullWidth
                      ></mu-text-field>
                    </mu-col>
                  </mu-row>
                  <button type="submit" style="display: none"></button>
                  <mu-raised-button
                    :disabled="isSending"
                    @click.native="submitForm"
                    type="button"
                    label="Reset Password"
                    secondary
                    fullWidth>
                  </mu-raised-button>
<!--                  <mu-row class="noAccount">-->
<!--                    <mu-col>-->
<!--                      Don't have an account yet?-->
<!--                    </mu-col>-->
<!--                    <mu-col>-->
<!--                      <router-link to="/register">Sign up</router-link>-->
<!--                    </mu-col>-->
<!--                  </mu-row>-->
                </form>
<!--                <mu-row class="noAccount last">-->
<!--                  <mu-col>-->
<!--                    <router-link to="/login">I just want to sign in</router-link>-->
<!--                  </mu-col>-->
<!--                </mu-row>-->
              </mu-card-text>
            </mu-card>
          </mu-col>
          <mu-col desktop="25" tablet="25"></mu-col>
        </mu-row>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>
<script>
  import LoginApi from '../../api/Login'
  import PasswordStrengthValidation from "../../components/PasswordStrengthValidation/PasswordStrengthValidation";
  import MessageBox from "../../components/FlashMessage/MessageBox";
  import FlashMessageMixin from "../../mixins/FlashMessageMixin";
  import HCPMIxin from "../../mixins/HCPMixin";

  export default {
    mixins: [
      FlashMessageMixin
    ],
    components: {
      PasswordStrengthValidation,
      MessageBox
    },
    data() {
      return {
        model: {
          password: null,
          password_confirm: null,
          token: "",
        },
        isSending: false,
      }
    },
    computed: {
      confirmPassErr: function() {
        let self = this;
        let error = self.errors.first('password_confirmation')
        if (error === "The Confirm Password confirmation does not match.") {
          return 'Please enter passwords that match';
        } else {
          return error;
        }
      }
    },
    mounted() {
      let self = this;
      if (_.has(self.$route.query, 'token')) {
        self.model.token = self.$route.query.token;
      } else {
        /**
         * No token set, redirect back to login page.
         */
        self.$router.push({
          name: 'Login'
        })
      }
    },
    methods: {
      triggerValidate() {
        this.$validator.validateAll();
      },
      submitForm() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid === true) {
            self.isSending = true;
            LoginApi.updatePasswordWithToken(self.model)
              .then(function (response) {
                self.$toastr.success("Password was successfully reset, you may now login in to your account");
                self.$router.push({
                  name: "Login"
                })
              })
              .catch(function (error) {
                self.$toastr.error("There was an error processing your request, please request a NEW password reset email")
                self.isSending = false;
              })
          }
        })
      }
    }
  }
</script>

<style>
  div#reset-password {
    background-image: url('../../../static/pw/hero-image.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-position-y: -400px;
  }
  .resetTitle {
    margin-bottom: 10px!important;
  }
</style>
<style scoped lang="less">
  .last {
    margin-bottom: 0px !important;
  }

  .fullHeight {
    height: 100%;
    min-height: 100%;
    max-height: 100%;
  }

  .noAccount {
    font-size: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    color: #9B9B9B;
  }

  a {
    color: #0179d5 !important;
    text-decoration: underline !important;
  }
  .logo {
    margin: 5px 0 20px;
    img {
      display: block;
      margin: 0 auto;
    }
  }
  .reset-block {
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    padding: 10px 15px 15px;
    .mu-card-header {
      padding-bottom: 0;
    }
    .mu-raised-button {
      margin-top: 15px;
      font-weight: 500;
      letter-spacing: 0.7px;
      font-size: 1.1em;
    }

  }
</style>



// WEBPACK FOOTER //
// PasswordReset.vue?e06d06e6